module.exports = __webpack_public_path__ + "img/pdf-sav-bg.8e7420f.jpg";